import { AdminUnitDetail } from "types";
import apiClient from "../lib/apiClients";

// Get departments under an admin unit
export const getchDepartmentUnderAdminUnit = async (uuid: any) => {
  const response = await apiClient.get<any>(
    `/crime_case_management/case-creations/departments-by-admin-unit/?admin_unit_uuid=${uuid}`,
  );
  return response?.data;
};

// Get child org units
export const fetchChildOrgUnits = async (uuid: any) => {
  const response = await apiClient.get<any>(
    `/crime_case_management/case-creations/child-org-units/?parent_org_unit_uuid=${uuid}`,
  );
  return response?.data;
};

// Get child admin units
export const fetchChildAdminUnits = async (uuid: any) => {
  const response = await apiClient.get<any>(
    `/crime_case_management/case-creations/child-admin-units/?parent_admin_unit_uuid=${uuid}`,
  );
  return response?.data;
};

// Get admin unit detail
export const fetchAdminUnitDetail = async (admin_unit: any, org_unit?: any) => {
  const url = org_unit
    ? `/appeal/appeal-requests/user-org-details/?admin_unit_uuid=${admin_unit}&org_unit_uuid=${org_unit}`
    : `/appeal/appeal-requests/user-org-details/?admin_unit_uuid=${admin_unit}`;

  const response = await apiClient.get<AdminUnitDetail>(url);
  return response?.data;
};
